import { Image, ImageFit, Link, PrimaryButton } from 'office-ui-fabric-react';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { SrOnlyText } from '../SrOnlyText/SrOnlyText';
import lilogo from '../../assets/LinkedIn-Icon.svg';
import { body1Font, body2Font, caption2Font, subhead3Font } from '../Typography/Typography';

export interface IPeopleDetailPreBindProps {
  /**
   * Title
   */
  title?: string;

  /**
   * Subtitle
   */
  subtitle?: string;

  /**
   * Name of the person to connect to
   */
  connectingUserName?: string;

  /**
   * An event handler to connect with LI
   */
  onConnectClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

  /**
   * A button component that will handle connecting to LI.
   */
  linkedInBindButton?: JSX.Element;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const Title = styled.h2`
  ${subhead3Font}
  color: #323130;
  font-weight: 400;
  margin: 25px 0 6px 0;
`;

const RenderTitle = (props: Pick<IPeopleDetailPreBindProps, 'title'>) => {
  const { title = 'LinkedIn' } = props;
  return <Title>{title}</Title>;
};

const Subtitle = styled.h3`
  ${body2Font}
  color: #323130;
  font-weight: normal;
  padding: 0 0 33px 0;
  margin: 0;
  text-align: center;
`;

const RenderSubtitle = (props: Pick<IPeopleDetailPreBindProps, 'subtitle' | 'connectingUserName'>) => {
  const { subtitle = 'Sign in to enable connecting with ', connectingUserName } = props;
  return (
    <Subtitle>
      <div>{subtitle}</div>
      <div>{connectingUserName}</div>
    </Subtitle>
  );
};

const LinkedInButton = styled(PrimaryButton)`
  ${body1Font}
  margin: 0px 0 12px 0;
`;

const StyledLinkedInLink = styled(Link)`
  padding-left: 5px;
`;

const JoinNow = styled.div`
  ${caption2Font}
`;

export const PeopleDetailPreBind: FunctionComponent<IPeopleDetailPreBindProps> = props => {
  const { onConnectClick, linkedInBindButton, title, subtitle, connectingUserName } = props;

  const linkedInButtonJSX = linkedInBindButton || (
    <LinkedInButton onClick={onConnectClick}>
      Yes, Let's go!
      <SrOnlyText>Opens in a new window.</SrOnlyText>
    </LinkedInButton>
  );

  return (
    <Container>
      <Image
        src={lilogo}
        styles={{
          root: { margin: '48px 0 0px 0', height: 42, width: '100%' },
        }}
        imageFit={ImageFit.contain}
        alt="LinkedIn"
      />
      <RenderTitle title={title} />
      <RenderSubtitle subtitle={subtitle} connectingUserName={connectingUserName} />
      <div>{linkedInButtonJSX}</div>
      <JoinNow>
        Not on LinkedIn?
        <StyledLinkedInLink href="https://www.linkedin.com/signup/cold-join" target="_blank">
          Join now
        </StyledLinkedInLink>
      </JoinNow>
    </Container>
  );
};

export default PeopleDetailPreBind;
